<template>
    <div class="nav">
      <div>
        <div class="nav_logo">
            <a class="nav_href">
              <img src="../../assets/images/j-i2.png" alt="">
              <!-- <img src="../../assets/images/logo.png" alt=""> -->
            </a>
        </div>
        <div class="nav-phone-box" ><a class="nav_phone" @click="telphone" ></a></div>
         <div class="nav_search" @click="goShops">
            <input class="nav_search_content" :disabled='isIndex' v-model="value" @keyup.enter="search(value)" type="text" placeholder="基因调控生命的进程">
            <input class='nav_search_submit' @click="search(value1)" type="submit" value="">
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'navHeader',
  props: {
    isIndex: Boolean,
    value1: String
  },
  data () {
    return {
      placeholder: '请输入搜索内容',
      value: ''
    }
  },
  created() {
    // console.log(this.value1)
    if(this.value1 != ''){
      this.value = this.value1
    }
  },
  methods: {
    telphone () {
      this.$emit('getTelPhone')
    },
    search (value) {
      this.$emit('getSearch', value)
    },
    goShops () {
      this.$emit('goshops')
    }
  }
}
</script>
<style scoped lang='less'>
.index_nav{
  background:#fff;
  padding: 16px 15px 16px;
   .index_nav_search{
    height: 30px;
    line-height: 30px;
    border: none;
    background: #ECECF0;
    color: #333333;
    .nav_search_content {
      width: 100%;
      height: 28px;
      line-height: 28px;
      padding-left: 18px;
      font-size: 12px;
      float: left;
      box-sizing: border-box;
      color: #333;
    }
    .nav_search_submit {
      width: 30px;
      height: 28px;
      background: url(../../assets/images/ys1.png) center center no-repeat;
      -webkit-background-size: 19px auto;
      border: none;
      z-index: 5;
      cursor: pointer;
      -webkit-background-size: 15px auto;
      background-size: 15px auto;
      position: absolute;
      right: 0;
    }
  }
}
.nav {
  width: 100%;
  // height: 40px;
  background: #fff;
  line-height: 40px;
  padding: 16px 15px 16px;
  box-sizing: border-box;
  font-size: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .nav_logo{
    float: left;
    width: 40px;
    height: 20px;
    padding-top:2px;
    margin-right: 10px;
    .nav_href{
      width: 100%;
      display: inline-block;
      img {
        width: 100%;
      }
    }
  }
  .nav_search{
    // width: 80%;
    height: 28px;
    // height: 30px;
    line-height: 28px;
    // line-height: 30px;
    border: none;
    background: #fff;
    // margin: auto;
    // float: left;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    .nav_search_content {
      width: 100%;
      height: 28px;
      line-height: 28px;
      padding-left: 18px;
      font-size: 12px;
      float: left;
      box-sizing: border-box;
      color: #333;
      background-color: #EDEDEF;
    }
    .nav_search_submit {
      width: 30px;
      height: 28px;
      background: url(../../assets/images/ys1.png) center center no-repeat;
      -webkit-background-size: 19px auto;
      border: none;
      z-index: 5;
      cursor: pointer;
      -webkit-background-size: 15px auto;
      background-size: 15px auto;
      position: absolute;
      right: 0;
    }
  }
  .nav-phone-box{
    width: 35px;
    // margin-left: 5px;
    float: right;
    padding-top:2px;
    .nav_phone{
      display: block;
      background: url('../../assets/images/ytel1.png') center center no-repeat;
      -webkit-background-size: cover;
      background-size: cover;
      width: 24px;
      height: 24px;
      margin: 0 auto;
      margin-right: 0;
    }
  }
}
</style>
